import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-to-up-icon',
  templateUrl: './navigation-arrow-to-up.component.html'
})
export class NavigationArrowToUpComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
